module.exports = __webpack_public_path__ + "static/projektowanie-opakowan-grafika-f05ee5e17daa3ddc4f9cc4f85d50eded.jpg";